"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFileRequest = void 0;
var media_platform_1 = require("../../../types/media-platform/media-platform");
/**
 * Upload File Request
 * @doc UploadFileRequest
 */
var UploadFileRequest = /** @class */ (function () {
    function UploadFileRequest(data) {
        this.acl = media_platform_1.ACL.PUBLIC;
        this.mimeType = 'application/octet-stream';
        if (data.acl) {
            this.acl = data.acl;
        }
        if (data.age) {
            // strong validation of age type
            var age = typeof data.age === 'string' ? parseInt(data.age, 10) : data.age;
            this.lifecycle = JSON.stringify({
                action: media_platform_1.Lifecycle.Delete,
                age: age,
            });
        }
        if (data.mimeType) {
            this.mimeType = data.mimeType;
        }
    }
    return UploadFileRequest;
}());
exports.UploadFileRequest = UploadFileRequest;
//# sourceMappingURL=upload-file-request.js.map